// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"f4df1510","453":"b2f1fd03"}[chunkId] + ".chunk.js";
};